updateCache